import React from 'react'
import ReactModal from 'react-modal'
import { FileItemType } from '../../containers/LessonPage/types'

// Styles
import './styles.scss'

// Icons
import IconLink from './images/iconLink'
import IconClose from './images/iconClose'

export default ({
  isOpen,
  onClose,
  title,
  items,
}: {
  isOpen: boolean
  onClose: () => void
  title: string
  items?: FileItemType[]
}) => {
  const customStyles: any = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    content: {
      width: 565,
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      borderRadius: 50,
      padding: 0,
      zIndex: 1000,
      overflow: 'none',
    },
  }

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
    >
      <div className={'modal'}>
        <button className={'modal__close'} onClick={onClose}>
          <IconClose />
        </button>
        <span className={'modal__title'}>{title}</span>
        <div className={'modal__row'}>
          {items?.length
            ? items.map(file => (
                <a
                  key={file.media_file_id}
                  target={'_blank'}
                  href={file.file.url}
                  className={'modal__row-item'}
                  rel="noreferrer"
                >
                  <div className={'info'}>
                    <span className={'info__title'}>{file.file.name}</span>
                    <span className={'info__url'}>{file.file.url}</span>
                  </div>
                  <IconLink />
                </a>
              ))
            : null}
        </div>
      </div>
    </ReactModal>
  )
}
